// QuotationPreview.js
import React, { useEffect, useState , useContext } from "react";
import { useLocation, useNavigate  } from "react-router-dom";
import { PDFViewer } from "@react-pdf/renderer";
import axios from "axios";
import InvoicePDF from "../../../Admin/Tharun/Pdf2"; // same InvoicePDF.js you already have
import baseURL from "../../../../Apiurs/Apiurls";
import { AuthContext } from "../../../../AuthContext/Authcontext";

const QuotationPreview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userName, userEmail, userMobile, userRole } = useContext(AuthContext);

  const { data, leadInfo, quotationData, quotationNumber, discount, discountType } =
    location.state || {};

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/company/1`);
        console.log("🏢 Company fetched:", response.data); // ✅ Debug log
        setCompany(response.data);
        setLoading(false);
      } catch (err) {
        console.error("❌ Fetch error:", err);
        setError("Company data not found");
        setLoading(false);
      }
    };
    fetchCompany();
  }, []);

  if (!data || !leadInfo || quotationData === undefined) {
    return <p>No quotation data found. Go back and generate again.</p>;
  }

  if (quotationData.length === 0) {
    return <p>No products available in this quotation.</p>;
  }

  if (loading) {
    return <p>Loading company info...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

    // ✅ Create "regards" object to send to PDF
  const regardsInfo = {
    name: userName || "N/A",
    email: userEmail || "N/A",
    mobile: userMobile || "N/A",
    role: userRole || "N/A",
  };

  console.log("regardsInfo:" , regardsInfo);

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <div
        style={{
          padding: "10px",
          display: "flex",
          justifyContent: "space-between",
          background: "#f8f9fa",
        }}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            padding: "8px 12px",
            background: "#6c757d",
            color: "white",
            border: "none",
            borderRadius: "5px",
          }}
        >
          ← Back
        </button>
      </div>

      <PDFViewer width="100%" height="100%">
        <InvoicePDF
          data={data}
          leadInfo={leadInfo}
          quotationData={quotationData}
          quotationNumber={quotationNumber}
          discount={discount}
          discountType={discountType}
          companyInfo={company} // ✅ Pass company details here
          regardsInfo={regardsInfo} // 👈 new prop for “Regards” info
        />
      </PDFViewer>
    </div>
  );
};

export default QuotationPreview;
